import { useState, useMemo } from "react";
import Sheets from "./sheets";
import Descs from "./descs";
import MatchTable from "./matchTable";

const Main = (props, ref) => {
    const [TargetListSheet, SetTargetListSheet] = useState([]);
    const [TargetListDesc, SetTargetListDesc] = useState([]);
    const [Page, SetPage] = useState(1);

    const renderPage = useMemo(() => {
        return (
            <>
                <div className={Page === 1 ? "" : "d-none"}>
                    <Sheets setTarget={SetTargetListSheet} />
                </div>
                <div className={Page === 2 ? "" : "d-none"}>
                    <Descs setTarget={SetTargetListDesc} />
                </div>
            </>
        );
    }, [Page]);

    return (
        <section className={"admin-owner-change"}>
            <h1>Owner Change</h1>
            <div className={"main-content"}>
                <div className={"select-tables"}>
                    <div className={"d-flex gap-5 mb-5"}>
                        <button
                            className={`bpl-btn success ${Page === 1 && "filled"}`}
                            onClick={() => SetPage(1)}
                        >
                            MBR Sheet
                        </button>
                        <button
                            className={`bpl-btn success ${Page === 2 && "filled"}`}
                            onClick={() => SetPage(2)}
                        >
                            Description
                        </button>
                    </div>

                    {renderPage}
                </div>
                <div className={"match-info"}>
                    <MatchTable sheets={{list: TargetListSheet, set: SetTargetListSheet}} descs={{list: TargetListDesc, set: SetTargetListDesc}} />
                </div>
            </div>
        </section>
    );
};

export default Main;
